/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2 } from '@coursera/cds-core';

import DottedSeparator from 'bundles/unified-description-page-common/components/shared/DottedSeparator';
import { durationToHours } from 'bundles/unified-description-page-common/utils/learningTime';

import _t from 'i18n!nls/xdp';

export type ModuleItemSubtitleElement = React.ReactElement<Props, typeof ModuleItemSubtitle>;

const styles = {
  container: css`
    display: flex;
    margin-top: var(--cds-spacing-50);
    flex-wrap: wrap;
  `,
};

type Props = {
  moduleIndex: number;
  totalContentDuration?: string | null;
};

const ModuleItemSubtitle = ({ moduleIndex, totalContentDuration }: Props) => {
  return (
    <Typography2 variant="bodySecondary" color="supportText" component="div" css={styles.container}>
      <FormattedMessage message={_t('Module {moduleIndex}')} moduleIndex={moduleIndex} />
      {totalContentDuration && (
        <React.Fragment>
          <DottedSeparator />
          <FormattedMessage
            message={_t('{learningTime} to complete')}
            learningTime={durationToHours(totalContentDuration)}
          />
        </React.Fragment>
      )}
    </Typography2>
  );
};

export default ModuleItemSubtitle;
